/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const hamburger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 14h14M1 8h14M1 2h14"
    />
  </svg>
)
export default hamburger
